// BackgroundImagePreloader.tsx
import { ImgWrapper } from "components/ImgContainer/ImgWrapper";
import React from "react";

const BackgroundImagePreloader = ({ imageUrls = [], limit = 5 }) => {
  // Render a limited number of images invisibly to trigger caching
  return (
    <div style={{
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden",
      pointerEvents: "none",
    }}>
      {imageUrls.slice(0, limit).map((url, i) => (
        <ImgWrapper
          key={i}
          img={url?.UrlOriginal}
          alt={`preload-${i}`}
          imgStyle={{ width: 1, height: 1, visibility: "hidden" }}
        />
      ))}
    </div>
  );
};

export default BackgroundImagePreloader;
